/**
 * SmartcapStaggerComponent
 * Custom element that reveals child [data-stagger-item] elements with
 * cascading transition delays (150ms per card) on scroll entry.
 * Respects prefers-reduced-motion and re-initialises in theme editor.
 */
class SmartcapStaggerComponent extends HTMLElement {
  connectedCallback() {
    this.triggered = false;
    this.observer = null;
    this._onSectionLoad = this._handleSectionLoad.bind(this);
    document.addEventListener('shopify:section:load', this._onSectionLoad);
    this._init();
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    if (this.observer) this.observer.disconnect();
  }

  _handleSectionLoad(event) {
    const section = this.closest(`#shopify-section-${event.detail.sectionId}`);
    if (!section) return;
    this._reset();
    this._init();
  }

  _reset() {
    const items = this.querySelectorAll('[data-stagger-item]');
    items.forEach((item) => {
      item.style.transitionDelay = '';
      item.classList.remove('sc-stagger--visible');
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.triggered = false;
  }

  _init() {
    const items = this.querySelectorAll('[data-stagger-item]');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('sc-stagger--visible'));
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || this.triggered) return;
        this.triggered = true;
        items.forEach((item, index) => {
          item.style.transitionDelay = `${index * 150}ms`;
          item.classList.add('sc-stagger--visible');
        });
        this.observer.disconnect();
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this);
  }
}

if (!customElements.get('smartcap-stagger')) {
  customElements.define('smartcap-stagger', SmartcapStaggerComponent);
}
